const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

async function refreshToken() {
  const refresh = localStorage.getItem('refresh_token');
  if (!refresh) return false;

  try {
    const res = await fetch(`${API_URL}/api/auth/refresh`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refresh_token: refresh }),
    });

    if (!res.ok) return false;

    const data = await res.json();
    localStorage.setItem('access_token', data.access_token);
    if (data.refresh_token) {
      localStorage.setItem('refresh_token', data.refresh_token);
    }
    return true;
  } catch {
    return false;
  }
}

async function request(endpoint, options = {}) {
  const token = localStorage.getItem('access_token');
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`${API_URL}${endpoint}`, { ...options, headers });

  if (res.status === 401) {
    const refreshed = await refreshToken();
    if (refreshed) {
      headers['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
      return fetch(`${API_URL}${endpoint}`, { ...options, headers });
    }
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    window.location.href = '/login';
    return res;
  }

  return res;
}

export const api = {
  signup: (data) =>
    request('/api/auth/signup', {
      method: 'POST',
      body: JSON.stringify(data),
    }),
  login: (data) =>
    request('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify(data),
    }),
  getMe: () => request('/api/auth/me'),
  logout: () =>
    request('/api/auth/logout', {
      method: 'POST',
      body: JSON.stringify({
        refresh_token: localStorage.getItem('refresh_token'),
      }),
    }),
  googleLogin: () => {
    window.location.href = `${API_URL}/api/auth/google`;
  },
  githubLogin: () => {
    window.location.href = `${API_URL}/api/auth/github`;
  },
};
